import React, { useEffect, useState } from "react";
import { Users, Shield, GraduationCap, Briefcase } from "lucide-react";
import { motion } from "framer-motion";
import { connect } from "react-redux";
import { DcddTotalUserProps } from "modules/report/dcdd_report/state/actionType";
import { fetchMembershipCount } from "../state/action";

interface UserStats {
  label: string;
  count: number;
  icon: JSX.Element;
  color: string;
}
interface DcddUserDataPros {
  commercialDcddUserData: DcddTotalUserProps | null;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps & DcddUserDataPros;

const MembershipStaticsData: React.FC<Props> = ({ onMembershipCountData, membershipCountState, commercialDcddUserData }) => {
  const data = membershipCountState?.membershipCount
  const [stats, setStats] = useState<UserStats[]>([]);
  useEffect(() => {
    onMembershipCountData()
  }, [onMembershipCountData])

  useEffect(() => {
    setTimeout(() => {
      setStats([
        {
          label: "Total Membership",
          count: data?.total_count,
          icon: <Shield className="w-8 h-8" />,
          color: "from-red-500 to-red-700",
        },
        {
          label: "Basic Membership",
          count: data?.basic_user_count,
          icon: <Briefcase className="w-8 h-8" />,
          color: "from-yellow-500 to-amber-600",
        },
        {
          label: "Standard Membership",
          count: data?.standard_user_count,
          icon: <GraduationCap className="w-8 h-8" />,
          color: "from-blue-500 to-indigo-600",
        },
        {
          label: "Premium Membership",
          count: data?.premium_user_count,
          icon: <GraduationCap className="w-8 h-8" />,
          color: "from-blue-500 to-indigo-600",
        },
      ]);
    }, 1000);
  }, [commercialDcddUserData, membershipCountState]);

  return (
    <div className="">
      {stats.length > 0 ? (
        <div className="from-gray-50 to-gray-200 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center px-6 pt-16">
          <motion.div
            className="max-w-5xl w-full"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-3xl font-bold text-gray-800 dark:text-gray-100 mb-10 text-center flex items-center justify-center gap-2">
              <Users className="w-7 h-7 text-blue-500" />
              User Membership Statistics
            </h1>
            {/* Cards Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {
                stats.map((item, index) => (
                  <motion.div
                    key={index}
                    className={`bg-gradient-to-r ${item.color} text-white rounded-2xl shadow-lg p-6 flex flex-col items-center justify-center`}
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.2 + index * 0.1, type: "spring" }}
                  >
                    <div className="mb-3">{item.icon}</div>
                    <p className="text-lg font-medium">{item.label}</p>
                    <h2 className="text-4xl font-extrabold mt-2">{item.count}</h2>
                  </motion.div>
                ))
             }
            </div>
            {/* Footer */}
            <motion.div
              className="mt-10 text-gray-600 dark:text-gray-400 text-center text-sm"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8 }}
            >
              <p>Last updated: {new Date().toLocaleDateString()}</p>
            </motion.div>
          </motion.div>
        </div>
      ) : (
        <p className="text-center col-span-full text-gray-500 dark:text-gray-400">
        </p>
      )}
    </div>
  );
};
const mapStateToProps = (state: any) => ({
  membershipCountState: state.commercialTotalDataReducer.membershipCountState,
});
const mapDispatchToProps = (dispatch: any) => ({
  onMembershipCountData: () =>
    dispatch(fetchMembershipCount()),
});
export default connect(mapStateToProps, mapDispatchToProps)(MembershipStaticsData);
